/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, October 1st 2021, 7:26:04 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { OSAlert } from "ui-widgets/alerts/Alert";

/**
 * Wrapper that returns a feedback alert if an expected list of items is empty
 *
 */
export interface EmptyListWrapperProps<T> extends React.HTMLProps<HTMLDivElement> {
  items: T[];
  noDataMessage?: React.ReactNode;
}

const EmptyListWrapper = <T,>({ items, noDataMessage, children, ...props }: EmptyListWrapperProps<T>) => {
  return items && items.length <= 0 ? (
    <NoDataComponent noDataMessage={noDataMessage} />
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};

const NoDataComponent = ({ noDataMessage }) =>
  typeof noDataMessage === "string" ? (
    <OSAlert severity="info" variant="outlined">
      {noDataMessage ?? "No Items available"}
    </OSAlert>
  ) : (
    noDataMessage
  );

export default EmptyListWrapper;
